import type { ListRenderItem } from "@shopify/flash-list";
import { useCallback, useMemo } from "react";
import { GatheringHeaderInfoFragmentFragment } from "src/api/graphql/__generated__/graphql";
import useDim from "src/hooks/useDim";
import { enumNever } from "src/shared/helpers/generalHelpers";
import GatheringPublicFullHeader from "../../GatheringPublicFullHeader";
import GatheringPublicFullRow from "../components/GatheringPublicFullRow";
import { GatheringPublicFullBodyItem } from "../types";
import useGatheringPublicFullBodySpacing from "./useGatheringPublicFullBodySpacing";

const useGatheringPublicFullBodyRenderItem = ({
	numColumns,
	thumbnail,
}: {
	numColumns: number;
	thumbnail: GatheringHeaderInfoFragmentFragment["thumbnail"];
}) => {
	const { containerHorizontalPadding, spacing } = useGatheringPublicFullBodySpacing();
	const dim = useDim();
	const width = useMemo(() => {
		return (
			(dim.width - 2 * containerHorizontalPadding - spacing * (numColumns - 1)) / numColumns
		);
	}, [containerHorizontalPadding, dim.width, numColumns, spacing]);
	const gatheringPublicFullBodyRenderItem = useCallback<
		ListRenderItem<GatheringPublicFullBodyItem>
	>(
		({ item, target }) => {
			const { variant } = item;
			switch (variant) {
				case "Header":
					return <GatheringPublicFullHeader thumbnail={thumbnail} />;
				case "Row":
					return <GatheringPublicFullRow row={item} itemWidth={width} target={target} />;
				default:
					return enumNever(variant);
			}
		},
		[width, thumbnail],
	);
	return { gatheringPublicFullBodyRenderItem };
};
export default useGatheringPublicFullBodyRenderItem;
